export const headersExcel = [
    {
        text: 'ID',
        value: 'id',
        sortable: true,
    },
    {
        text: 'NOME',
        value: 'name',
        sortable: true,
    },
    {
        text: 'ID MODELO',
        value: 'modelID',
        sortable: true,
    },
    {
        text: 'DATA CRIACAO',
        value: 'createdDate',
        sortable: true,
    },
    {
        text: 'ID USUARIO',
        value: 'accountID',
        sortable: true,
    },
    {
        text: 'ID VEICULO',
        value: 'vehicleID',
        sortable: true,
    },
    {
        text: 'ID TECNICO',
        value: 'technicianID',
        sortable: true,
    },
    {
        text: 'ATIVO',
        value: 'active',
        sortable: true,
    },
    {
        text: 'ID TIPO EQUIPAMENTO',
        value: 'equipmentTypeID',
        sortable: true,
    },
    {
        text: 'MAC',
        value: 'mac',
        sortable: true,
    },
    {
        text: 'ID CLIENTE',
        value: 'clientID',
        sortable: true,
    },
    {
        text: 'DATA ALTERACAO PLACA',
        value: 'updatedDatePlate',
        sortable: true,
    },
    {
        text: 'PLACA',
        value: 'plate',
        sortable: true,
    },
    {
        text: 'TECNICO',
        value: 'technician',
        sortable: true,
    },
    {
        text: 'MODELO',
        value: 'model',
        sortable: true,
    },
    {
        text: 'USUARIO',
        value: 'account',
        sortable: true,
    },
    {
        text: 'TIPO',
        value: 'type',
        sortable: true,
    },
    {
        text: 'CLIENTE',
        value: 'client',
        sortable: true,
    },
    {
        text: 'DESCRICAO',
        value: 'description',
        sortable: true,
    },
];
